export default __webpack_public_path__ + "static/balance_3-8962b3d36b29e477b3f6c41bf5530d7c.jpg";